import { ApiResponse, PackageUIResponse } from "../../models/ApiResponse";
import { PackageResponse } from "../../models/responseModels/packageResponse";
import { axiosRequests } from "../axiosRequest";

export const PackageAgent = {
  getPackageList: () =>
    axiosRequests.get<PackageUIResponse>("/fdc-commandops/package/GetPackageList"),
  //   packageCsvDownload: (packageData: PackageResponse[]) =>
  //     axiosRequests.post<PackageDownloadResponse>(
  //       "/package/DownloadCsv",
  //       packageData
  //     ),
  packageXlsxDownload: (packageData: PackageResponse[]) =>
    axiosRequests.postXlsx<Blob>("/fdc-commandops/package/DownloadXlsx", packageData),
  //   updatePackage: (packageData: UpdatePackageRequest) =>
  //     axiosRequests.post<ApiResponse>("/package/updatePackage", packageData),
  //   addPackage: (packageData: AddPackageRequest) =>
  //     axiosRequests.post<ApiResponse>("/package/addPackage", packageData),
};
